import React, {useEffect, useState, useContext} from 'react';
import Cookies from 'js-cookie';
import './EmbeddedComponent.less';
import {ButtonPrimary} from '@homeaway/react-buttons';
import {TrackingContext} from '@homeaway/react-event-tracking';
import {createCookie, cookieExists, APP_BANNER_COOKIE_NAME} from '../utils/cookies';
import * as BannerDefaults from '../banner-defaults';
import * as BannerHelpers from '../utils/bannerHelpers';
import {triggerEdapEvent} from '../utils/triggerEdapEvent';

export const EmbeddedComponent = ({buttonLabel,
    embeddedButtonLabel,
    ctaLink,
    embeddedTitle,
    embeddedDescription,
    travelerApp,
    showBanner,
    useCanonicalPath}) => {
    embeddedButtonLabel = BannerHelpers.getButtonLabel(buttonLabel);
    const context = useContext(TrackingContext);
    const brandName = BannerHelpers.getBrandName(travelerApp);
    const site = BannerHelpers.getSite(brandName);
    const imgUrl = BannerHelpers.getImgUrl(site);
    embeddedTitle = embeddedTitle || BannerDefaults.TITLE.replace('brand', brandName);
    embeddedDescription = embeddedDescription || BannerDefaults.DESCRIPTION;

    function createLink() {
        return BannerHelpers.getDownloadLink(ctaLink, brandName, Cookies.get('hav'), Cookies.get('xdid'));
    }

    const [path, setPath] = typeof window !== 'undefined' ? useState(window.location) : '';

    const [showEmbeddedState, setShowEmbeddedState] = useState(false);
    const [embeddedSelected, setEmbeddedSelected] = useState(null);
    const [embeddedPresented, setEmbeddedPresented] = useState(null);
    const [link, setLink] = useState(createLink());

    useEffect(() => {
        if (cookieExists(APP_BANNER_COOKIE_NAME) || embeddedSelected) {
            setShowEmbeddedState(false);
        } else {
            setShowEmbeddedState(showBanner);
        }
    });

    useEffect(() => {
        if (useCanonicalPath && typeof window !== 'undefined') {
            setPath(window.location);
        }
    }, [path]);

    useEffect(() => {
        if (!embeddedPresented && !cookieExists(APP_BANNER_COOKIE_NAME) && showEmbeddedState) {
            triggerEdapEvent(context, 'presented', 'embedded');
            setEmbeddedPresented(true);
        }
    });

    function handleDownloadButtonClick() {
        setEmbeddedSelected(true);
        triggerEdapEvent(context, 'selected', 'embedded');
        if (useCanonicalPath) {
            setLink(`${link}&$canonical_url=${path}`);
        }
        createCookie();
    }

    return (
        <div className="embedded__popup">
            {showEmbeddedState &&
                <div className="confirmation-item visible-xs">
                    <div className="embedded">
                        <div className="embedded__container">
                            <div className="embedded__app-icon">
                                <img src={imgUrl} alt={`${brandName} Logo`}/>
                            </div>
                            <div className="embedded__heading-text">
                                {embeddedTitle}
                            </div>
                            <div className="embedded__sub-heading-text">
                                {embeddedDescription}
                            </div>
                            <div className="embedded__download-button-div">
                                <ButtonPrimary onClick={handleDownloadButtonClick} href={link} data-testid="download-button-content" className="embedded__get-app-icon" key={2} label={embeddedButtonLabel} />
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>
    );
};
